import { render, staticRenderFns } from "./ScrollCta.vue?vue&type=template&id=6be1f646"
import script from "./ScrollCta.vue?vue&type=script&lang=js"
export * from "./ScrollCta.vue?vue&type=script&lang=js"
import style0 from "./ScrollCta.vue?vue&type=style&index=0&id=6be1f646&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports